import React, { useRef } from 'react';
import { Select, Checkbox } from 'antd';
import classnames from 'classnames';
import TriangleDownIcon from '@web-common/components/UI/Icons/svgs/TriangleDown';
import TagCloseIcon from '@web-common/components/UI/Icons/svgs/TagCloseSvg';
import listStyle from './classifyList.module.scss';
import { getIn18Text } from 'api';
const AccountSelect = ({ selectedAccount, setSelectedAccount, optionsList, _account }) => {
    const selectRef = useRef(null);
    const handleChange = (account) => {
        setSelectedAccount((selectedAccount) => {
            if (selectedAccount.includes(account)) {
                return selectedAccount.filter(i => i !== account);
            }
            return selectedAccount.concat(account);
        });
    };
    const selectAll = () => {
        setSelectedAccount((selectedAccount) => {
            if (selectedAccount.length === optionsList.length) {
                return [];
            }
            return optionsList.slice(0);
        });
    };
    const dropdownRender = () => {
        return (React.createElement("div", { className: classnames(listStyle.optionWrapper) },
            React.createElement("div", { className: classnames(listStyle.option), onClick: selectAll, hidden: !optionsList.length },
                React.createElement(Checkbox, { checked: selectedAccount.length === optionsList.length }),
                React.createElement("span", null,
                    getIn18Text('YIXUAN'),
                    "(",
                    selectedAccount.length,
                    ")")),
            optionsList.map(account => {
                return (React.createElement("div", { className: classnames(listStyle.option), onClick: () => {
                        handleChange(account);
                    } },
                    React.createElement(Checkbox, { key: account, checked: selectedAccount.includes(account) }),
                    React.createElement("span", null, account)));
            })));
    };
    const onDeselect = (account) => {
        setSelectedAccount((selectedAccount) => {
            return selectedAccount.filter(act => act !== account);
        });
    };
    const onClear = () => {
        setSelectedAccount([]);
    };
    return (React.createElement("div", { className: classnames(listStyle.selectWrapper), ref: selectRef },
        React.createElement("span", { className: classnames(listStyle.title) }, getIn18Text('GUIZESHIYONGZHANG')),
        React.createElement(Select, { mode: "multiple", style: { width: '100%' }, maxTagCount: 'responsive', placeholder: getIn18Text('XUANZEGUIZESHI'), getPopupContainer: () => selectRef.current || document.body, dropdownRender: dropdownRender, allowClear: true, onDeselect: onDeselect, onClear: onClear, showArrow: true, suffixIcon: React.createElement(TriangleDownIcon, { className: "dark-invert" }), removeIcon: React.createElement(TagCloseIcon, { className: "dark-invert" }), value: selectedAccount })));
};
export default AccountSelect;
